import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-formas-de-pago',
  templateUrl: './add-formas-de-pago.component.html',
  styleUrls: ['./add-formas-de-pago.component.css']
})
export class AddFormasDePagoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
